import { configureStore } from "@reduxjs/toolkit";

import { enableMapSet } from "immer";
import CreatorSuggestion from "./CreatorSuggestion/CreatorSuggestion";
import blogReducer from "./blogs/blogSlice";
import scriptReducer from "./chatScript/slices/scriptSlice";
import collectionsReducer from "./collections/collectionsSlice";
import commonReducer from "./commons/commonSlice";
import discoversReducer from "./discovers/discoversSlice";
import feedsReducer from "./feeds/feedsSlice";
import filesReducer from "./files/filesSlice";
import liveStreamStatsReducer from "./lives/liveDataSlice";
import livesReducer from "./lives/livesSlice";
import mediaPushReducer from "./mediaPush/mediaPushSlice";
import messagesReducer from "./messages/messagesSlice";
import quickMessagesReducer from "./messages/quickMessagesSlice";
import quickFileReducer from "./quickFile/quickFileSlice";
import reactionsReducer from "./reactions/reactionsSlice";
import trackingLinksReducer from "./trackingLinks/slices/trackingLinkSlice";
import monetizationsReducer from "./users/monetizationsSlice";
import usersReducer from "./users/usersSlice";

enableMapSet();
const store = configureStore({
  reducer: {
    users: usersReducer,
    monetizations: monetizationsReducer,
    feeds: feedsReducer,
    files: filesReducer,
    mediaPushes: mediaPushReducer,
    messages: messagesReducer,
    quickMessages: quickMessagesReducer,
    lives: livesReducer,
    reactions: reactionsReducer,
    quickFile: quickFileReducer,
    suggestion: CreatorSuggestion,
    liveStreamStats: liveStreamStatsReducer,
    collections: collectionsReducer,
    discovers: discoversReducer,
    common: commonReducer,
    script: scriptReducer,
    blog: blogReducer,
    trackingLinks: trackingLinksReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["mediaPushes/setSelectFiles"],
        ignoredPaths: ["suggestion.suggestionByTypeList", "mediaPushes.files"],
      },
    }),
});

export type StoreState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
